/**
 * Router-state key set by list pages after create/rotate. A detail page
 * reads it once to reveal the fresh token; a reload clears it, matching
 * the "show only once" security model.
 */
export const CREDENTIAL_TOKEN_STATE_KEY = 'credentialToken' as const

export type CredentialTokenNavState = {
  [CREDENTIAL_TOKEN_STATE_KEY]?: string
}

/**
 * Placeholder used in the Quick Start curl example — deliberately not a real
 * URL. Each bound app defines its own endpoint / request body / response
 * shape, so the sample can only show the shape, not a runnable command.
 */
export const APP_ENDPOINT_PLACEHOLDER = '<APP_ENDPOINT>'
